import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Divider,
  Button,
} from "@mui/material";

export const AboutUsPage = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Header Section */}
      <Box textAlign="center" sx={{ mb: 6 }}>
        <Typography variant="h3" gutterBottom>
          About Us
        </Typography>
        <Typography variant="h6" color="textSecondary">
          Empowering Small Retailers, One Store at a Time
        </Typography>
      </Box>

      {/* Our Dream Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          Our Dream
        </Typography>
        <Typography variant="body1">
          At ShareStock, we believe in the power of community and collaboration. Our dream is to
          empower local brick-and-mortar retail stores by creating a platform that levels the
          playing field against big-box chains and e-commerce giants. We envision a world where
          small businesses thrive, supported by each other, and where every transaction builds a
          stronger, more vibrant retail ecosystem.
        </Typography>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* Our Mission Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          Our Mission
        </Typography>
        <Typography variant="body1">
          <strong>To give power back to smaller brick-and-mortar retail stores.</strong>
        </Typography>
        <Typography variant="body1">
          We achieve this by providing an innovative platform where retailers can connect,
          collaborate, and share resources. Whether it’s finding a new supplier, liquidating excess
          stock, or sourcing products on short notice, ShareStock is here to ensure small businesses
          have the tools they need to succeed. We’re not just a marketplace — we’re a community.
        </Typography>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* What We Do Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          What We Do
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Connect Small Businesses
                </Typography>
                <Typography variant="body1">
                  Retailers can network and collaborate, building relationships that go beyond
                  transactions.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Simplify Supply Management
                </Typography>
                <Typography variant="body1">
                  Our platform makes it easy to share and stock products, ensuring no store is left
                  empty-handed.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Promote Sustainability
                </Typography>
                <Typography variant="body1">
                  By redistributing excess inventory among stores, we help reduce waste and maximize
                  resources.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Foster Growth
                </Typography>
                <Typography variant="body1">
                  We’re here to help your business scale — whether it’s by expanding your product
                  offerings or finding your next trusted partner.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* Why ShareStock Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          Why ShareStock?
        </Typography>
        <Typography variant="body1">
          We understand the unique challenges small retailers face because we’ve been there.
          ShareStock was built with the needs of small businesses in mind:
        </Typography>
        <ul>
          <li><Typography variant="body1">By Retailers, For Retailers: Our team includes former store owners and retail enthusiasts who know the ins and outs of running a shop.</Typography></li>
          <li><Typography variant="body1">Community-Driven: Every feature on our platform is designed to foster collaboration and mutual support.</Typography></li>
          <li><Typography variant="body1">Empowering the Underdog: We’re passionate about giving smaller stores the tools to compete and win in an ever-changing retail landscape.</Typography></li>
        </ul>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* Our Story Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          Our Story
        </Typography>
        <Typography variant="body1">
          ShareStock started as a simple idea: what if small retailers could help each other by
          sharing resources? This idea quickly grew into a mission to transform the way
          brick-and-mortar businesses operate. From a small group of dreamers with big ideas,
          ShareStock has grown into a thriving platform, helping retailers across the country
          achieve more together.
        </Typography>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* Join the Movement Section */}
      <Box textAlign="center" sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          Join the Movement
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          Are you ready to empower your store and join a community of like-minded retailers? We’d
          love to have you on board. Explore ShareStock today and see how we’re making a difference.
        </Typography>
        <Button variant="contained" color="primary" size="large">
          Get Started
        </Button>
      </Box>
    </Container>
  );
};

export default AboutUsPage;
